import { render, staticRenderFns } from "./ProductAddonCustom.vue?vue&type=template&id=b10ac372&scoped=true&"
import script from "./ProductAddonCustom.vue?vue&type=script&lang=js&"
export * from "./ProductAddonCustom.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddonCustom.vue?vue&type=style&index=0&id=b10ac372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10ac372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VIcon,VRow})
